import React, { useEffect, useState } from 'react';
import MuiTable from '../../components/MuiTable/MuiTable';
import { updateFlashBar, updateIsLoading } from '../../redux/action';
import { useDispatch } from 'react-redux';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import qs from 'qs';
import { Column } from '../../components/MuiTable/ViewData';
import { SortOrderType } from '../../config/enum';
import { totalPages } from '../../config/helpers';
import Filter from '../../components/Filter/Filter';
import { IndexProps } from './WebsiteDetailsAdmin';

type RequestProps = {
  DmcaGenerated: boolean | null;
  IsArchived: boolean;
  siteOrganizationId: string | undefined | null;
  SiteOrganizationIndexId: string;
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string;
};

type ResultProps = {
  id: string;
  weblinkUrl: string;
  generatedDmca: boolean;
};

type ResponseProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results: ResultProps[];
};

type WebsiteArchivesProps = {
  siteOrganizationId: string | undefined | null;
  siteOrganizationIndexId: string;
  siteOrganizationIndexName: string;
  allsiteOrganizationIndexId: IndexProps[];
};

const columns: Column[] = [
  {
    id: 'weblinkUrl',
    label: 'Weblinks',
    minWidth: 400,
    align: 'left',
  },
  {
    id: 'categoryName',
    label: 'Category Name',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'categoryLable',
    label: 'Category Label',
    minWidth: 120,
    align: 'left',
  },

  {
    id: 'keywordText',
    label: 'Keyword',
    minWidth: 400,
    align: 'left',
  },
];

const WebsiteArchives = (props: WebsiteArchivesProps) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [requestWeblink, setRequestWeblink] = useState<RequestProps>({
    DmcaGenerated: null,
    IsArchived: true,
    siteOrganizationId: props.siteOrganizationId,
    SiteOrganizationIndexId: props.siteOrganizationIndexId,
    Page: page,
    PageSize: limit,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });

  const [weblinks, setWebLinks] = useState<ResultProps[]>([]);
  const [siteIndex, setSiteIndex] = useState([{ name: '', value: '' }]);

  const [siteIndexLabel, setSiteIndexLable] = useState(
    props.siteOrganizationIndexName === undefined
      ? 'Select Index'
      : props.siteOrganizationIndexName + ' (Active) '
  );

  useEffect(() => {
    getWebLinks(requestWeblink);
    setSiteIndex(
      props.allsiteOrganizationIndexId.map((item: IndexProps) => {
        if (item.isActive) {
          return {
            name: item.name + ' (Active) ',
            value: item.id,
          };
        } else {
          return {
            name: item.name,
            value: item.id,
          };
        }
      })
    );
  }, []);

  const getWebLinks = (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/weblinks?${queryString}`;
    instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResponseProps) => {
    if (data.results !== null) {
      setWebLinks(data.results as ResultProps[]);
      setTotalRowCount(data.totalCount);
      dispatch(updateIsLoading(false));
    } else {
      setWebLinks([]);
      dispatch(updateIsLoading(false));
    }
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getWebLinks({ ...requestWeblink, Page: page, PageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...requestWeblink,
          Page: page + 1,
          PageSize: limit,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getWebLinks({
          ...requestWeblink,
          Page: page - 1,
          PageSize: limit,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getWebLinks({
          ...requestWeblink,
          Page: 1,
          PageSize: limit,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getWebLinks({
          ...requestWeblink,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getWebLinks({
        ...requestWeblink,
        Page: 1,
        PageSize: item,
      });
      setLimit(item);
      setPage(1);
    },
  };
  const filterHandler = (row: any) => {
    getWebLinks({
      ...requestWeblink,
      Page: page,
      PageSize: limit,
      SiteOrganizationIndexId: row.value,
    });
    setRequestWeblink({ ...requestWeblink, SiteOrganizationIndexId: row.value });
    setSiteIndexLable(row.name);
  };
  return (
    <div className="bg-white">
      <div className="sm:flex items-center justify-between p-3">
        <div className="font-semibold text-lg">Archives</div>
        <div>
          {' '}
          <Filter
            filterHandler={filterHandler}
            rootFilter={siteIndex}
            label={siteIndexLabel}
            heading="Select Index"
          />
        </div>
      </div>
      <MuiTable
        columns={columns}
        rows={weblinks}
        page={page}
        limit={limit}
        paginateHandler={paginateHandler}
        totalRowCount={totalRowCount}
      />
    </div>
  );
};

export default WebsiteArchives;
